<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bc7"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('teamVehicleReview_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="
            getLimit('teamVehicleReview_batchReport_button') &&
              loginkTarget != 0 &&
              !isAutomaticReport
          "
          @click="getSelectEvent()"
        >
          批量上报
        </el-button>
        <el-button
          v-if="getLimit('teamVehicleReview_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :cell-class-name="cellClassName"
      class="mytable-style"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="authStatusExt"
          title="审核状态"
          :formatter="formatterAuthStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authTime"
          min-width="420"
          title="审核时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.authTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'authTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authMsg"
          title="驳回原因"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.authMsg"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="licenseNumber"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseColor"
          title="车牌颜色"
          :formatter="formatterCehicleLicenseColor"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleLicenseColor"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.vehicleLicenseColorList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车辆行驶证档案编号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入车辆行驶证档案编号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="classificationCode"
          title="车辆分类"
          :formatter="formatterVehicleClassification"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.classificationCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.vehicleClassificationList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isFreeze"
          title="是否冻结"
          :formatter="formatterIsFreeze"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isFreeze"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in isFreezeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseDueDate"
          title="车辆行驶证到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.vehicleLicenseDueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'vehicleLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="roadTransportCertificateDate"
          title="道路运输证到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.roadTransportCertificateDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'roadTransportCertificateDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="owner"
          title="车主姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.owner"
            placeholder="请输入车主姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="车主电话"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入车主电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="roadTransportCertificateNumber"
          title="道路运输证号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.roadTransportCertificateNumber"
            placeholder="请输入车辆道路运输证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleEnergyType"
          title="能源类型"
          :formatter="formatterVehicleEnergyType"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleEnergyType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.vehicleEnergyTypeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="totalWeight"
          title="总质量/挂车车头整备质量(Kg)"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadWeight"
          title="核定载质量/准牵引总质量(Kg)"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isHasTrailer"
          title="是否挂车"
          :formatter="formatterHasTrailer"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isHasTrailer"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in isHasTrailers"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="trailerNum"
          title="挂车车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.trailerNum"
            placeholder="请输入挂车车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isCtms">
        <vxe-table-column
          field="netStatus"
          title="是否入网"
          :formatter="formatterNetStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.netStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in netStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isSendLoginkExt"
          :formatter="formatterIsSendLogink"
          title="是否上报"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendLoginkExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in isSendLoginkOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" fixed="right" min-width="190">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('teamVehicleReview_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDetail(scope.row.code, 'detail')"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <!-- 审核 -->
          <el-tooltip
            v-if="
              getLimit('teamVehicleReview_audit_button') &&
                ((scope.row.authStatusExt != 3 && groupLevel == 0) ||
                  (scope.row.authStatusExt != 3 &&
                    scope.row.authStatus == 3 &&
                    groupLevel != 0) ||
                  (scope.row.authStatusExt != 3 &&
                    scope.row.authStatus != 0 &&
                    groupLevel != 0) ||
                  (scope.row.authStatusExt != 3 &&
                    scope.row.authStatus == 0 &&
                    groupLevel != 0))
            "
            class="item"
            effect="dark"
            content="审核"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDetail(scope.row.code, 'review')"
            >
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('teamVehicleReview_checkTruckExist_button') &&
                scope.row.authStatusExt === 3 &&
                scope.row.netStatus === 0
            "
            class="item"
            effect="dark"
            content="入网验证"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcCheckTruckExist(scope.row.licenseNumber)"
            >
              <i class="el-icon-check" />
            </vxe-button>
          </el-tooltip>
          <!-- 上报 -->
          <el-tooltip
            v-if="
              getLimit('teamVehicleReview_report_button') &&
                scope.row.authStatusExt === 3 &&
                !(scope.row.isSendLoginkExt == 1 && loginkTarget == 7) &&
                loginkTarget != 0 &&
                !(isAutomaticReport && scope.row.isSendLoginkExt != 2)
            "
            class="item"
            effect="dark"
            content="上报"
            placement="top"
          >
            <vxe-button type="text" @click="reportLogink(scope.row.code)">
              <i class="el-icon-edit-outline" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('teamVehicleReview_print_button')"
            effect="dark"
            content="打印"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="Printing(scope.row.code, scope.row.licenseNumber)"
            >
              <i class="el-icon-printer" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelDetailFlag"
      :title="modelTtile"
      width="1200"
      height="800"
      resize
    >
      <compDetail
        ref="detailRef"
        :parent-data="parentData"
        @fatherMethods="fatherMethods"
      />
    </vxe-modal>

    <!-- 审核 -->

    <!-- 报文 -->
    <vxe-modal
      v-model="datagramFlag"
      title="报文详情"
      width="800"
      height="600"
      resize
    >
      <datagramDetail
        ref="datagramRef"
        :parent-data="{
          vehicleLengthList,
          vehicleWidthList,
          vehicleHighList,
          vehicleTonnageList
        }"
      />
    </vxe-modal>
    <vxe-modal
      v-model="Printingxianyin"
      title="打印"
      width="900"
      height="80%"
      resize
    >
      <Printinging ref="dayinRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import datagramDetail from "./components/datagramDetail.vue";
import compDetail from "./components/vehicleDetail.vue";
import { vehicle } from "@/api/transport";
import { getListDict } from "@/api/commonApi";
import { getRole } from "@/utils/getRole";
import { reportVehicleInfo, checkTruckExist } from "@/api/driver";
import Printinging from "@/views/basicInfo/driver/platVehicle/components/Printing";
export default {
  name: "TeamVehicleReview",
  components: {
    compDetail,
    datagramDetail,
    Printinging
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/vehicle/exportTeamVehicleAuthList", //导出接口
        name: "车队车辆"
      },
      isCtms: true, //默认显示  同城系统隐藏
      Printingxianyin: false,
      loading: false,
      tableData: [],
      modelDetailFlag: false,
      vehicleReviewFlag: false,
      datagramFlag: false,
      modelTtile: "详情",
      listQuery: {
        gmtCreatedRange: [],
        vehicleLicenseDueDateRange: [],
        roadTransportCertificateDateRange: [],
        authTimeRange: [],
        branchCodeExt: "",
        code: "",
        licenseNumber: "",
        driverPhone: "",
        branchCode: "",
        teamCode: "",
        licensePlateType: "",
        classificationCode: "",
        roadTransportCertificateNumber: "",
        roadTransportCertificateImg: "",
        roadTransportCertificateDate: "",
        loadWeight: "",
        loadVolume: "",
        remainingLoadWeight: "",
        remainingLoadVolume: "",
        vehicleLicenseColor: "",
        vehicleLicenseImg: "",
        vehicleLicenseDueDate: "",
        vehicleImg: "",
        isHasTrailer: "",
        trailerNum: "",
        trailerVehicleLicenseImg: "",
        trailerRoadTransport: "",
        trailerRoadTransportCertificateImg: "",
        trailerVehicleImg: "",
        authStatus: "",
        authStatusExt: "",
        loadStatus: "",
        isFreeze: "",
        locationSource: "",
        terminalNumber: "",
        driverIsFreeze: "",
        isTeamVehicle: 1,
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      vehicleLengthList: [],
      vehicleWidthList: [],
      vehicleHighList: [],
      vehicleTonnageList: [],
      parentData: {
        model: "detail",
        isDetail: true,
        vehicleClassificationList: [],
        vehicleEnergyTypeList: [],
        locationSourceList: [],
        vehicleLicenseColorList: []
      },
      // 审核状态
      authStatusOptions: [
        { label: "未审核", value: 0 },
        // { label: "审核中", value: 1 },
        { label: "审核驳回", value: 2 },
        { label: "审核通过", value: 3 }
      ],
      // 是否冻结
      isFreezeOptions: [
        { label: "未冻结", value: 0 },
        { label: "已冻结", value: 1 }
      ],
      // 是否冻结
      isHasTrailers: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 车辆属性
      vehicleAttributeOptions: [
        { label: "外协", value: 0 },
        { label: "自有", value: 1 }
      ],
      // 是否入网
      netStatusOptions: [
        { label: "未入网", value: 0 },
        { label: "已入网", value: 1 }
      ],
      loginkTarget: 0,
      isSendLoginkOptions: [
        {
          label: "未上报",
          value: 0
        },
        {
          label: "已上报",
          value: 1
        },
        {
          label: "上报失败",
          value: 2
        }
      ],
      groupLevel: 0
    };
  },
  computed: {
    ...mapState({
      isAutomaticReport: state => state.user.party.isAutomaticReport
    }),
    model() {
      return this.parentData.model;
    }
  },
  watch: {
    model(val) {
      this.modelTtile = val === "review" ? "审核" : "详情";
    }
  },
  created() {
    // 获取数据字典： 车型，车长，车宽，车高，吨位，定位来源，车牌颜色
    getListDict({
      types:
        "vehicleClassification,vehicleLength,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource,vehicleLicenseColor,vehicleEnergyType"
    }).then(response => {
      this.parentData.vehicleClassificationList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
      this.vehicleTonnageList = response.data.filter(
        item => item.type === "vehicleTonnage"
      )[0]["dictList"];
      this.parentData.locationSourceList = response.data.filter(
        item => item.type === "locationSource"
      )[0]["dictList"];
      this.parentData.vehicleLicenseColorList = response.data.filter(
        item => item.type === "vehicleLicenseColor"
      )[0]["dictList"];
      this.parentData.vehicleEnergyTypeList = response.data.filter(
        item => item.type === "vehicleEnergyType"
      )[0]["dictList"];
      let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
      this.loginkTarget = dataBranch.partyGroupConfigCacheMap
        .loginkTarget_reportProvince
        ? dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince
            .configValue
        : 0;
      this.findList();
    });
    let isCtmsShow = getRole(); //获取登录用户登录的是否是同城系统
    this.isCtms = !isCtmsShow;
    this.listQuery.branchCodeExt = JSON.parse(
      localStorage.getItem("dataBranch")
    ).code;
    this.groupLevel = JSON.parse(localStorage.getItem("dataBranch")).level;
  },
  methods: {
    // 设置重量小数点后三位
    setkey(value, key) {
      this.$set(this.listQuery, key, value.replace(/\.[0-9]+/, ""));
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        vehicle(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },

    // 详情方法
    funcDetail(code, prefix) {
      this.$refs.detailRef.getInfo(code);
      this.modelDetailFlag = true;
      this.$set(this.parentData, "model", prefix);
    },
    fatherMethods() {
      this.vehicleReviewFlag = !this.vehicleReviewFlag;
      this.modelDetailFlag = false;
      this.findList();
    },
    // 入网验证
    funcCheckTruckExist(c) {
      this.$confirm("确认验证吗？").then(_ => {
        const carNum = c;
        const rLoading = this.openLoading();
        checkTruckExist({ carNum }).then(response => {
          rLoading.close();
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译车型
    formatterVehicleClassification({ cellValue }) {
      const item = this.parentData.vehicleClassificationList.find(
        item => item.code === cellValue
      );
      return item ? item.name : "";
    },
    // 翻译车牌颜色
    formatterCehicleLicenseColor({ cellValue }) {
      const item = this.parentData.vehicleLicenseColorList.find(
        item => item.code === cellValue
      );
      return item ? item.name : "";
    },
    // 翻译是否冻结
    formatterIsFreeze({ cellValue }) {
      const item = this.isFreezeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译定位来源
    formatterLocationSource({ cellValue }) {
      const item = this.parentData.locationSourceList.find(
        item => item.code == cellValue
      );
      return item ? item.name : "";
    },
    formatterVehicleAttribute({ cellValue }) {
      const item = this.vehicleAttributeOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译是否入网
    formatterNetStatus({ cellValue }) {
      const item = this.netStatusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterHasTrailer({ cellValue }) {
      const item = this.isHasTrailers.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    //打印
    Printing(code, licenseNumber) {
      this.$refs.dayinRef.getInfo(code, licenseNumber);
      this.Printingxianyin = true;
    },
    // 翻译能源类型
    formatterVehicleEnergyType({ cellValue }) {
      const item = this.parentData.vehicleEnergyTypeList.find(
        item => item.code === cellValue
      );
      return item ? item.name : "";
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      const overDueType = row.overDueType || [];
      //驾驶证
      if (column.property === "driverLicenseDueDate") {
        if (overDueType.indexOf("driver") > -1) {
          return "col-red";
        }
      }
      //形驶证
      if (column.property === "vehicleLicenseDueDate") {
        if (overDueType.indexOf("vehicle") > -1) {
          return "col-red";
        }
      }
      //从业资格证
      if (column.property === "workLicenseDueDate") {
        if (overDueType.indexOf("work") > -1) {
          return "col-red";
        }
      }
      //从业资格证
      if (column.property === "roadTransportCertificateDate") {
        if (overDueType.indexOf("road") > -1) {
          return "col-red";
        }
      }
      //身份证
      if (column.property === "idCardDueDate") {
        if (overDueType.indexOf("idCard") > -1) {
          return "col-red";
        }
      }
    },
    // 报文详情
    funcSendDataGram(code) {
      this.datagramFlag = true;
      this.$refs.datagramRef.getDriver(code);
    },
    // 上报
    reportLogink(c) {
      this.$confirm("确认上报监管平台吗？").then(_ => {
        const codes = c;
        const rLoading = this.openLoading();
        reportVehicleInfo({ codes })
          .then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          })
          .finally(() => {
            this.findList();
          });
      });
    },
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择实际承运人", type: "warning" });
      } else {
        const codes = selectRecords.map(item => item.code).join(",");
        this.$confirm("确认上报监管平台吗？").then(_ => {
          const rLoading = this.openLoading();
          reportVehicleInfo({ codes })
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
            })
            .finally(() => {
              this.findList();
            });
        });
      }
    },
    formatterIsSendLogink({ cellValue }) {
      let item = this.isSendLoginkOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    checCheckboxkMethod2({ row }) {
      return row.isSendLoginkExt != 1;
    }
  }
};
</script>
<style scoped>
.mytable-style .vxe-body--column.col-red {
  background-color: red;
  color: #fff;
}
</style>
